import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import ProductCreate from "./ProductCreate";
import ProductEdit from "./ProductEdit";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getProducts } from "../../../helpers/urlConfig/apiFunctions";
import DeleteComponent from "../../../Components/Common/deleteComponent/DeleteComponent";
import { dateChangerFunc, dateParser } from "../../../helpers/dateParser";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { documentTitle } from "../../../helpers/documentTitle";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

const ProductList = () => {
  const [modal_list, setmodal_list] = useState(false);
  const [modal_delete, setmodal_delete] = useState(false);
  const [edit_modal_list, set_edit_modal_list] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [deleteId, setDeleteProductId] = useState(null);
  const [deleteName, setDeleteProductName] = useState(null);

  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // Search query state

  const tog_list = () => setmodal_list(!modal_list);
  const edit_tog_list = () => set_edit_modal_list(!edit_modal_list);
  const tog_delete = () => setmodal_delete(!modal_delete);

  documentTitle("Products");

  const fetchData = async () => {
    try {
      const response = await getProducts();

      if (response.statusCode === 200) {
        setProducts(response.data);
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEditClick = (product) => {
    setCurrentProduct(product);
    set_edit_modal_list(true);
  };

  const onClickRemoveBtn = (products) => {
    setDeleteProductId(products.product_id);
    setDeleteProductName(products.product_name);
    tog_delete();
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter products based on the search query
  // const filteredProducts = products.filter((product) =>
  //   product.product_name.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  // Multi-field search functionality
  const filteredProducts = products.filter((product) => {
    const query = searchQuery.toLowerCase();
    return (
      product.product_name.toLowerCase().includes(query) ||
      product.hsn_code?.toString().includes(query) || // Convert age to string for search
      product.gst_percent?.toString().includes(query) // Convert age to string for search
    );
  });

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(products);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");
    XLSX.writeFile(workbook, "Products.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Products List", 14, 10);
    doc.autoTable({
      head: [
        ["SL.No", "Product Name", "HSN Code", "GST Percent", "Created At"],
      ],
      body: products.map((product, index) => [
        index + 1,
        product.product_name,
        product.hsn_code,
        product.gst_percent,
        dateParser(product.created_at),
      ]),
    });
    doc.save("Products.pdf");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Product List"
            pageTitle="Products"
            exportToExcel={exportToExcel}
            exportToPDF={exportToPDF}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div>
                          {getSessionData("user_type") === "SuperAdmin" && (
                            <Button
                              color="success"
                              className="add-btn me-1"
                              onClick={tog_list}
                              id="create-btn"
                            >
                              <i className="ri-add-line align-bottom me-1"></i>
                              Add{" "}
                            </Button>
                          )}
                          {/* <Button
                            color="primary"
                            onClick={exportToExcel}
                            className="me-1"
                          >
                            Excel
                          </Button>
                          <Button color="secondary" onClick={exportToPDF}>
                            PDF
                          </Button> */}
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                              value={searchQuery}
                              onChange={handleSearchChange}
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table className="table align-middle table-nowrap">
                        <thead className="table-light">
                          <tr>
                            <th>SL.No</th>
                            <th>Product Name</th>
                            <th>HSN Code</th>
                            <th>GST Percent</th>
                            <th>Created At</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredProducts &&
                            filteredProducts.map((products, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{products.product_name}</td>
                                <td>{products.hsn_code}</td>
                                <td>{products.gst_percent}</td>
                                <td>
                                  {dateChangerFunc(
                                    dateParser(products.created_at)
                                  )}
                                </td>

                                <td>
                                  <div className="d-flex gap-2">
                                    <div className="edit">
                                      <button
                                        className="btn btn-sm btn-success"
                                        onClick={() =>
                                          handleEditClick(products)
                                        }
                                      >
                                        Edit
                                      </button>
                                    </div>
                                    <div className="remove">
                                      <button
                                        className="btn btn-sm btn-danger"
                                        onClick={() =>
                                          onClickRemoveBtn(products)
                                        }
                                      >
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      {products.length === 0 && (
                        <div className="text-center mt-4">
                          <p>No products found.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ProductCreate
        modal_list={modal_list}
        setmodal_list={setmodal_list}
        tog_list={tog_list}
        fetchData={fetchData}
      />

      {edit_modal_list && (
        <ProductEdit
          modal_list={edit_modal_list}
          setmodal_list={set_edit_modal_list}
          tog_list={edit_tog_list}
          fetchData={fetchData}
          currentProduct={currentProduct}
        />
      )}

      <DeleteComponent
        modal_delete={modal_delete}
        tog_delete={tog_delete}
        fetchData={fetchData}
        deleteId={deleteId}
        keyName="Product"
        deleteName={deleteName}
      />

      <ToastContainer />
    </React.Fragment>
  );
};

export default ProductList;
